/* Dependencies */
import React, { useState, useEffect } from "react";
import { IntlProvider } from "react-intl";
import axios from "axios";

/* Others */
import { isBrazil, LANGUAGES } from "./utils";

/* Constants */
const REACT_APP_PRIVATE_WEB_MOBILE_VERSION = process.env.REACT_APP_PRIVATE_WEB_MOBILE_VERSION;

const IntlProviderWrapper = ({ children }) => {
  const localeLanguage = isBrazil ? LANGUAGES.PORTUGUESE_LANGUAGE : LANGUAGES.SPANISH_LANGUAGE;
  const [localeMessages, setLocaleMessages] = useState();

  /**
   * @description Fetches the locales file
   */
  useEffect(() => {
    axios(`/mobile/languages/${localeLanguage}.json?v=${REACT_APP_PRIVATE_WEB_MOBILE_VERSION}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Cache: "no-cache"
      },
      credentials: "same-origin"
    })
      .then((response) => {
        setLocaleMessages(response.data);
      })
      .catch(() => {
        setLocaleMessages({});
      });
  }, [localeLanguage]);

  return (
    <IntlProvider locale={localeLanguage} messages={localeMessages} key={localeLanguage}>
      {localeMessages && children}
    </IntlProvider>
  );
};

export default IntlProviderWrapper;
